import React from 'react'
import { Tab, Menu, Label } from 'semantic-ui-react';
import IssueLogs from './ActivityLogs/IssueLog';
import CommentLogs from './ActivityLogs/CommentLogs';
import AllLogs from './ActivityLogs/AllLogs'
class ActivityLogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {


        let activities = this.props.selectedDataById.activities
        let issues = [];
        let comments = [];
        let allLogs = []
        activities && activities.map((item, index) => {
            let phaseName = item.name;
            item && item.activities.map((item2, index) => {
                if (item2.isLeafNode) {
                    item2 && item2.issueLogComments && item2.issueLogComments.length > 0 && item2.issueLogComments.map((issue, index) => {

                        issues.push({
                            data: issue,
                            phase: phaseName,
                            //stage: stageName,
                            activityName: item2.name,
                            createdDate: item2.issueDate,
                        });
                        allLogs.push({
                            data: issue,
                            phase: phaseName,
                            //stage: stageName,
                            activityName: item2.name,
                            createdDate: item2.issueDate,
                            type: "issue"
                        });
                    });
                    item2 && item2.onHoldComments && item2.onHoldComments.length > 0 && item2.onHoldComments.map((onHold, index) => {
                        if (onHold.isImplicitOnHold) {
                            comments.push({
                                data: onHold,
                                phase: phaseName,
                                //stage: stageName,
                                createdDate: item2.actiavteOnHoldDate,
                                activityName: item2.name
                            });
                            allLogs.push({
                                data: onHold,
                                phase: phaseName,
                                //stage: stageName,
                                createdDate: item2.actiavteOnHoldDate,
                                activityName: item2.name,
                                type: "hold"
                            });
                        }
                    });
                } else {
                    let stageName = item2.name
                    item2 && item2.activities.map((leaf, index) => {
                        leaf && leaf.issueLogComments && leaf.issueLogComments.length > 0 && leaf.issueLogComments.map((issue, index) => {
                            issues.push({
                                data: issue,
                                phase: phaseName,
                                stage: stageName,
                                activityName: leaf.name,
                                createdDate: leaf.issueDate,
                            });
                            allLogs.push({
                                data: issue,
                                phase: phaseName,
                                stage: stageName,
                                activityName: leaf.name,
                                createdDate: leaf.issueDate,
                                type: "issue"
                            });
                        });
                        leaf && leaf.onHoldComments && leaf.onHoldComments.length > 0 && leaf.onHoldComments.map((onHold, index) => {
                            if (onHold.isImplicitOnHold) {
                                comments.push({
                                    data: onHold,
                                    phase: phaseName,
                                    stage: stageName,
                                    createdDate: leaf.actiavteOnHoldDate,
                                    activityName: leaf.name
                                });
                                allLogs.push({
                                    data: onHold,
                                    phase: phaseName,
                                    stage: stageName,
                                    createdDate: leaf.actiavteOnHoldDate,
                                    activityName: leaf.name,
                                    type: "hold"
                                });
                            }
                        });
                    })
                }
            })
        })

        const panes = [
            { menuItem: <Menu.Item key='All'> All<Label>{allLogs && allLogs.length}</Label></Menu.Item>, render: () => <AllLogs logs={allLogs} /> },
            { menuItem: <Menu.Item key='On Hold'> On Hold<Label>{comments && comments.length}</Label></Menu.Item>, render: () => <CommentLogs comments={comments} /> },
            { menuItem: <Menu.Item key='Issue'> Issue<Label>{issues && issues.length}</Label></Menu.Item>, render: () => <IssueLogs issues={issues} /> },
        ]


        return (
            <div>
                <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
            </div>
        )
    }
}

export default ActivityLogs